import { Component, input } from '@angular/core';
import { BackupRef } from '../../../service/api/backup.service';
import { LoadingComponent } from '../../loading/loading.component';
import { BackupComponent } from '../backup.component';

@Component({
  selector: 'app-backup-list',
  templateUrl: './backup-list.component.html',
  styleUrls: ['./backup-list.component.scss'],
  imports: [LoadingComponent, BackupComponent]
})
export class BackupListComponent {

  readonly list = input<BackupRef[]>();
  readonly origin = input('');

}
